import { getConfig } from "@engaging-tech/ssr-config"
import React from "react"

import Loader from "../../features/happinessSurvey/containers/Loader"
import RankYourCompany from "../../features/happinessSurvey/containers/RankYourCompany"
import { CountriesLoader, IndustriesLoader, SurveyJobRolesLoader } from "../../features/misc"
import GradientLayout from "../../layouts/GradientLayout"

// All four loaders mirror what Welcome.js mounts so that navigating directly
// to /happiness-survey/rank-company (e.g. bookmark or test) still populates
// Redux with the data the later questions need. All loaders are idempotent.
const happinessSurveyId = () => getConfig().surveyIds.whs

const RankCompany = () => (
  <GradientLayout>
    <Loader surveyId={happinessSurveyId()} />
    <CountriesLoader />
    <IndustriesLoader />
    <SurveyJobRolesLoader />
    <RankYourCompany />
  </GradientLayout>
)

export default RankCompany
